import * as THREE from "three";
import { Suspense,  useRef} from "react";
import gsap from "gsap";
import { Canvas } from "@react-three/fiber";
import {
  OrbitControls,
  PerspectiveCamera,
} from "@react-three/drei";
import Newearth from "./Newearth";
import { Background } from "./Background";

const Scene1 = (props) => {
  const cameraRef = useRef();

  if (props.goToMount) {
    gsap.to(cameraRef.current.position, {
      duration: 2,
      x: 30,
      z: 0,
      y: 0,
      ease: "power1.inOut",
    });
  }

  if (props.goToEarth && cameraRef.current) {
    gsap.to(cameraRef.current.position, {
      duration: 4.1,
      x: 45,
      y: 0,
      z: 0,
      ease: "power1.inOut",
    });
  }

  return (
    <div className="scene1cont">
      <Canvas
        linear
        style={{
          position: "fixed",
          top: "0",
          left: "0vh",
          width: "100vw",
          height: "100vh",
        }}
      >
        
        <Background />

        <PerspectiveCamera
          ref={cameraRef}
          far={40000}
          near={0.1}
          fov={45}
          makeDefault
          position={[35, 0, 0]}
        />

     

          <hemisphereLight
            position={[0, 40, 0]}
            groundColor={new THREE.Color("0xA1DD70")}
            color={new THREE.Color().setHSL(0.6, 1, 0.6)}
            intensity={3}
          />

          
        <Suspense fallback={null}>

          <Newearth position={[0, 1, 0]} />


        </Suspense>  

          <OrbitControls />
        
      </Canvas>
    </div>
  );
};

export default Scene1;
